import React from 'react';
import './inner-page-structure.css';
import { Container } from "@material-ui/core";
import Back from '../../../../main/back';
import SidebarSummary from '../sidebar-summary/sidebar-summary';

const InnerPageStructure = ({
    innerPageElements,
    children
 }) => {

	const {
		backLabel,
		title,
		sidebarSummary = null,
		headerAction = null
	} = innerPageElements;

  	return (
		<main className="inner-page-structure">
        	<div id="inner-page-structure__layout">
				<Back items={backLabel} title={backLabel.backLabel} />
				<Container maxWidth="lg" disableGutters>
					{title && (
						<div className="title-container">
							<h1 className="main-title">{title}</h1>
							<span className="title-shape"></span>
						</div>
					)}
					<div>
						{headerAction && (
							<div className="inner-page-structure__header-action">
								{headerAction}
							</div>
						)}

						{children}
					</div>
				</Container>
			</div>
            {sidebarSummary && (
        		<SidebarSummary {...sidebarSummary} />
      		)}
		</main>
  	);
};

export default InnerPageStructure;